export default "__VITE_ASSET__BWWtG3A___"